import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("kbd", {
  class: "DocSearch-Commands-Key",
  style: {"background":"var(--docsearch-key-gradient)"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "15",
    height: "15",
    "aria-label": "Enter key",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12 3.53088v3c0 1-1 2-2 2H4M7 11.53088l-3-3 3-3" })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_form_item, {
    label: "Поиск по названию узла или по названию группы узлов",
    "label-position": "top"
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_select, {
        modelValue: _ctx.foundJobsSelect,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.foundJobsSelect) = $event)),
        filterable: "",
        remote: "",
        "reserve-keyword": "",
        clearable: "",
        placeholder: "Узел (компонет) или название группы",
        "remote-method": _ctx.searchJobsAsync,
        onChange: _ctx.onJobComponentSearchResultsChange
      }, {
        empty: _withCtx(() => [
          _createTextVNode(" Ничего не найдено ☹️ ")
        ]),
        footer: _withCtx(() => [
          _hoisted_1
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foundJobsSelectItems, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "remote-method", "onChange"])), [
        [_directive_loading, _ctx.foundJobsSelectLoading]
      ])
    ]),
    _: 1
  }))
}